import React from 'react';

interface Props {
  id: string;
  visible: boolean;
  title: string;
  message: string;
  hint?: string;
}

const LoadingStatusModal = ({ id, visible, title, message, hint }: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      id={id}
      className="loading-status-modal-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-message`}
    >
      <div className="loading-status-modal">
        <div className="loading-status-modal__header">
          <div className="loading-status-modal__eyebrow">Updating design</div>
          <div id={`${id}-title`} className="loading-status-modal__title">{title}</div>
        </div>
        <div className="loading-status-modal__body">
          <div className="loading-status-modal__spinner" aria-hidden={true}>
            <div className="loading-status-modal__spinner-ring" />
          </div>
          <div className="loading-status-modal__copy">
            <div id={`${id}-message`} className="loading-status-modal__message">{message}</div>
            <div className="loading-status-modal__hint">{hint || 'Please keep this window open while we finish syncing the design.'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingStatusModal;
